"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHeadingIconsWrapper = exports.StyledEmptyFolderImage = exports.StyledEmptyButtonsWrapper = exports.StyledEmptyFolder = exports.StyledSearchWrapper = exports.StyledHeadingWrapper = exports.StyledWrapper = exports.StyledFolderWrapper = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledFolderWrapper = styled_components_1.default.div ``;
exports.StyledWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
exports.StyledHeadingWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;

  margin: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)} 0`};
`;
exports.StyledSearchWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  width: 100%;
  margin: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)} 0`};
`;
exports.StyledEmptyFolder = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%; //270px
  padding: 0 9px; // (288 - 270) / 2 = 9 270px;
  text-align: center;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};
  flex: 1;
`;
exports.StyledEmptyButtonsWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  margin-top: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};
`;
exports.StyledEmptyFolderImage = styled_components_1.default.div `
  margin-bottom: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)};

  i,
  svg {
    width: 200px;
    height: 200px;
  }
`;
exports.StyledHeadingIconsWrapper = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
`;
//# sourceMappingURL=Workspace.style.js.map